// Unpublished Work © 2020-2022 Deere & Company

import {SET_CONFIGURATION} from '../action-list';

export const setConfiguration = (configuration, user = {}) => ({
    configuration,
    user,
    type: SET_CONFIGURATION
});
